import { FiskalTssLogEntityConfig }                 from '@app/modules/fiskal-tss-log/presets/fiskal-tss-log-entity-config.model';
import { RequestState }                             from '@core/interfaces/api.interface';
import { IFiskalTssLogStorageMetadataEntityEvents } from '@core/interfaces/entity.interface';
import { EntityActionEventEnum }                    from '@models/entity.model';


// ENUMS #############################################################
// API enums *********************************************************
export enum FiskalExportStatusEnum {
	AVAILABLE = 'available',
	ACKNOWLEDGED = 'acknowledged',
	EXPIRED = 'expired',
	REMOVED = 'removed',
	REMOVED_IN_CLOUD_ONLY = 'removedInCloudOnly'
}

// UI enums *********************************************************
export enum FiskalTssLogDownloadModeEnum {
	Raw = 'raw',
	Decrypted = 'decrypted',
}

export enum FiskalTssLogPresetEnum {
	BUSINESS_PREMISES_DETAIL_FISKAL_TSS_LOG = 'businessPremisesDetailFiskalTssLog',
	TASK_CENTER_FISKAL_TSS_LOGS = 'taskCenterFiskalTssLogs'
}

export enum FiskalTssLogTagEnum {
	DOWNLOADED = 'downloaded'
}

// INTERFACES ########################################################
// API interfaces ****************************************************
export interface AccessInfo {
	accessKey: string;

	resourceUrl: string;
}

// UI interfaces *****************************************************
export interface IFiskalTssLogEntityActionEvent {
	fiskalTssLogMetadata: FiskalTssLogStorageMetadata;

	action: EntityActionEventEnum;

	fiskalTssLogEntityConfig?: FiskalTssLogEntityConfig;
}

// TYPES #############################################################
export type FiskalTssLogProps = ( keyof FiskalTssLogStorageMetadata )[];


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

export class BusinessPremisesLogInfoTMO {
	businessPremisesId?: string = undefined;

	lastUploadTime?: Date = undefined;
}

export class FiskalDownloadInfoTMO {
	downloadLink?: string = undefined;

	encryptionInfo?: FiskalEncryptionInfo = new FiskalEncryptionInfo();
}

export class FiskalEncryptionInfoTMO {
	contentEncryptionIV?: string = undefined;

	encryptionAgent?: FiskalEncryptionInfoEncryptionAgent = new FiskalEncryptionInfoEncryptionAgent();

	encryptionMode?: string = undefined;

	keyWrappingMetadata?: { [ key: string ]: string; } = undefined;

	wrappedContentKey?: FiskalEncryptionInfoWrappedContentKey = new FiskalEncryptionInfoWrappedContentKey();
}

export class FiskalEncryptionInfoEncryptionAgentTMO {
	encryptionAlgorithm?: string = undefined;

	protocol?: string = undefined;
}

export class FiskalEncryptionInfoWrappedContentKeyTMO {
	algorithm?: string = undefined;

	encryptedKey?: string = undefined;

	keyId?: string = undefined;
}

export class FiskalLogFileInfoTMO {
	checksumCompressed?: string = undefined;

	checksumUncompressed?: string = undefined;

	finalUploadFlag: boolean = undefined;

	lastSignatureCounter?: number = undefined;

	queryEndDate?: Date = undefined;

	queryStartDate?: Date = undefined;

	size?: number = undefined;
}

export class FiskalTssLogMetadataSummaryTMO {
	businessPremisesId?: string = undefined;
	createdBy?: string = undefined;
	createdDate?: Date = undefined;
	fccId: string = undefined;
	id?: string = undefined;
	lastExportTime?: Date = undefined;
	lastModifiedBy?: string = undefined;
	lastModifiedDate?: Date = undefined;
	organizationId?: string = undefined;
	tenantId: string = undefined;
	tssId: string = undefined;
	tssSerialNumber: string = undefined;
}

export class FiskalTssLogMetadataTMO {
	acknowledgeTime?: Date = undefined;

	archivedTime?: Date = undefined;

	businessPremisesId: string = undefined;

	createdBy?: string = undefined;

	createdDate?: Date = undefined;

	downloadDetails?: FiskalDownloadInfo = new FiskalDownloadInfo();

	expireTime?: Date = undefined;

	fccId: string = undefined;

	filename: string = undefined;

	isDownloaded?: boolean = undefined;

	lastModifiedBy?: string = undefined;

	lastModifiedDate?: Date = undefined;

	logFileDetails?: FiskalLogFileInfo = new FiskalLogFileInfo();

	status: FiskalExportStatusEnum = undefined;

	tssId?: string = undefined;

	tssSerialNumber: string = undefined;

	uploadTime?: Date = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class BusinessPremisesLogInfo extends BusinessPremisesLogInfoTMO {
	businessPremisesId?: string = undefined;

	lastUploadTime?: Date = undefined;

	public etag?: string = undefined;
}

export class FiskalDownloadInfo extends FiskalDownloadInfoTMO {}

export class FiskalEncryptionInfo extends FiskalEncryptionInfoTMO {}

export class FiskalEncryptionInfoEncryptionAgent extends FiskalEncryptionInfoEncryptionAgentTMO {}

export class FiskalEncryptionInfoWrappedContentKey extends FiskalEncryptionInfoWrappedContentKeyTMO {}

export class FiskalLogFileInfo extends FiskalLogFileInfoTMO {}

export class FiskalTssLogMetadataSummary extends FiskalTssLogMetadataSummaryTMO {}

export class FiskalTssLogStorageMetadata extends FiskalTssLogMetadataTMO {
	public id?: string = undefined; // unique identifier is the filename

	public isSelected?: boolean = undefined;

	public etag?: string = undefined;

	public ui?: IFiskalTssLogStorageMetadataEntityEvents = {

		daysLeftUntilDelete: undefined,

		isInGracePeriod: undefined,

		requestError: undefined,

		requestState: RequestState.NOT_ASKED,

		requestStateI18nPath: undefined,

		entityActions: {
			acknowledge: {
				isEnabled: true,
				showLoader: false
			},
			download: {
				isEnabled: true,
				showLoader: false
			}
		},

		availabilityStatusColor: undefined
	};
}

